<template>
  <div>
    <div
      v-if="invoice.chift_invoicing_external_id"
      class="flex gap-2 rounded px-1.5 font-semibold text-emerald-500"
    >
      <span><FontAwesomeIcon :icon="['fas', 'circle-check']" /></span>
      <span>{{ $t('global.sended') }}</span>
    </div>
    <BaseButton
      v-else
      theme-color="bg-secondary text-contrast-secondary"
      :title="$t('button.send_invoice_to_partner', { partner: partnerName })"
      icon="paper-plane"
      class="w-full"
      size="extra-small"
      inverse-icon-order
      :display-loader="sending"
      :disabled="sending"
      @click="sendToChiftInvoicing"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'ChiftInvoicingAccountingInvoiceComponent',
  components: { FontAwesomeIcon, BaseButton },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    partnerName: {
      type: String,
      required: false,
      default: 'Bill It'
    }
  },
  emits: ['success'],
  data() {
    return {
      sending: false
    }
  },
  methods: {
    ...mapActions({
      processSendToChiftInvoicingAction: 'invoicing/sendToChiftInvoicing'
    }),
    sendToChiftInvoicing() {
      this.sending = true
      this.processSendToChiftInvoicingAction({ invoice_id: this.invoice.id })
        .then((response) => {
          if (response?.success) {
            this.$h.toastSuccess(
              this.$t('toasts.invoice_sent_to_partner', {
                partner: this.partnerName
              })
            )
            this.$emit('success', true)
          } else {
            this.$h.toastDanger(response?.message || this.$t('toasts.something_went_wrong'))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>
